// extracted by mini-css-extract-plugin
export default {"rotate":"RotateScreen_rotate__qZrRC","image":"RotateScreen_image__aQvND"};